import { Box, Typography, styled } from "@mui/material";

import Card from "components/Card";

function CardInvitation({ title, number }) {
  return (
    <Card marginBottom={3}>
      <BoxStyle>
        <Typography
          variant="subtitle1"
          color="text.secondary"
          paddingBottom={2}
        >
          {title}
        </Typography>

        <Typography variant="h1" color="secondary.main" fontWeight={400}>
          {number}
        </Typography>
      </BoxStyle>
    </Card>
  );
}
const BoxStyle = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
}));
export default CardInvitation;
